import React, { useEffect, useState, useContext, useRef } from 'react';
import { Button, Avatar, Icon, Collapse, Tooltip, notification, message } from 'antd';
import {
  DetailsCard,
  UserProfilecover,
  UserDetailHeadingCover,
  UsersList,
  TeamDetailsCard,
  NoUser,
  ColorLegend,
} from './styles';
import Loader from '../../components/Loader';
import { LoginContainer } from '../../components/Modals/styles';
import { getAllTeams, getGroupPermission } from '../../utils/services/teamsAPI';
import { getUser } from '../../utils/services/userAPI';
import { AddTeamModal } from '../../components/Modals';
import DeleteUserModal from '../../components/Modals/DeleteUserModal';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { AppStoreContext } from '../../context/appStoreContext';
import { fetchUserDetails } from '../../utils/services/authAPI';
import { withTranslation } from 'react-i18next';
import { MANAGE_TEAM_SETTINGS } from './TranslationValues';
import { SUPPORT_EMAIL_ID } from '../../utils/helper';
const NAMESPACE = ['MANAGE_TEAM_SETTINGS'];
const TeamSettings = props => {
  const {t} = props;
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isEditTeam, setIsEditTeam] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState('');
  const [deleteModalVisible, setDeleteModalVisible] = useState(null);
  const [activeTeamTab, setActiveTeamTab] = useState('1');
  const [teamUserDetails, setTeamUserDetails] = useState([]);
  const [teamCount, setTeamCount] = useState(0);
  const [teamLimit, setTeamLimit] = useState(0);
  const [upgradeModal, setUpgradeModal] = useState(false);
  const [isCheckingLimit, setIsCheckingLimit] = useState(false);
  const { userDetails, setUserDetails, isEnterprise, checkUserAccess } = useContext(AppStoreContext);
  const { Panel } = Collapse;

  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    fetchData();
    setTeamLimit(userDetails.planMapping.team ? userDetails.planMapping.team : null);
  }, []);

  useEffect(() => {
    return () => {
      // notification.destroy();
      notification.close('Notification');
    };
  }, []);

  const fetchData = async () => {
    const response = await getAllTeams();
    let Userresponse = await getUser(userDetails.userType);
    let groupPermission = await getGroupPermission();
    if (response?.data) {
      activeTeamTab && isMountedRef.current && openNotification();
      setTeamCount(response?.dataCount);
    }
    setLoading(false);
    getAllDetails(response.data, groupPermission.data, Userresponse.data);
  };

  const onSuccess = () => {
    setShowModal(false);
    setIsEditTeam(false);
    fetchData();
  };

  const handleDeleteTeam = isDeleted => {
    setDeleteModalVisible(false);
    if (isDeleted) {
      fetchData();
    }
  };

  const onchange = activeTab => {
    setActiveTeamTab(activeTab);
    if (activeTab && isMountedRef.current) {
      openNotification();
    } else {
      notification.close('Notification');
    }
  };
  const openNotification = () => {
    const key = 'legend';
    notification.open({
      // message: 'Color legend',
      key: "Notification",
      description: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
          <ColorLegend>{t(MANAGE_TEAM_SETTINGS.USER_READ_ACCESS_POPUP_LABEL.key,MANAGE_TEAM_SETTINGS.USER_READ_ACCESS_POPUP_LABEL.value)}</ColorLegend>
          <ColorLegend write={1}>{t(MANAGE_TEAM_SETTINGS.USER_FULL_ACCESS_POPUP_LABEL.key,MANAGE_TEAM_SETTINGS.USER_FULL_ACCESS_POPUP_LABEL.value)}</ColorLegend>
        </div>
      </div>
      ),
      duration: 0,    
      placement: 'bottomLeft',
      style: {
        height: '125px',
        textAlign: 'center',
        width: '400px',
      },
    });
  };

  const getAllDetails = (teams, teamDetails, userDetails) => {
    let permissionMap = {};
    userDetails.forEach(user => {
      user.resourceGroupPermission.forEach(permissionId => {
        if (permissionMap[permissionId]) {
          permissionMap[permissionId] = [...permissionMap[permissionId], user];
        } else {
          permissionMap[permissionId] = [user];
        }
      });
    });
    let allteamUserDetails = teams.map((team, key) => {
      var info = { name: team.name, id: team.id, status: team.status };
      let permission = teamDetails.filter(permission => parseInt(permission.rgId, 10) === team.id);
      const writePermissionId = permission.filter(value => value.permission === 'write')[0].id;
      const readPermissionId = permission.filter(value => value.permission === 'read')[0].id;
      let writeAccess = permissionMap[writePermissionId] || [];
      let readAccess = permissionMap[readPermissionId] || [];
      return { ...info, permission, writeAccess, readAccess };
    });
    setTeamUserDetails(allteamUserDetails);
  };

  const renderList = () => {
    return (
      <Collapse defaultActiveKey={['0']} onChange={onchange} accordion>
        {teamUserDetails &&
          teamUserDetails.map((value, key) => {
            return (
              <Panel
                key={key}
                showArrow={false}
                header={
                  <DetailsCard key={key}>
                    <Tooltip placement="top" title={t(MANAGE_TEAM_SETTINGS.TEAM_INFORMATION_TOOLTIP.key,MANAGE_TEAM_SETTINGS.TEAM_INFORMATION_TOOLTIP.value)}>
                      <Icon type="info-circle" />
                    </Tooltip>
                    <UserProfilecover permission={true}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '65%',
                        }}
                      >
                        <Avatar className="avatar">{value.name.charAt(0).toUpperCase()}</Avatar>
                        <p>{value.name}</p>
                      </div>
                      <div style={{ width: '20%', fontWeight: 'bold', color: '#949090' }}>
                      {value.readAccess.length + value.writeAccess.length + ' ' + t(MANAGE_TEAM_SETTINGS.NUMBER_OF_USERS_LABEL.key,MANAGE_TEAM_SETTINGS.NUMBER_OF_USERS_LABEL.value)}
                      </div>
                    </UserProfilecover>
                  </DetailsCard>
                }
                extra={
                  <div
                    style={{
                      display: 'flex',
                      width: '90px',
                      justifyContent: 'space-around',
                      marginRight: '10px',
                    }}
                    onClick={e => e.stopPropagation()}
                  >
                    <Tooltip placement="top" title={t(MANAGE_TEAM_SETTINGS.EDIT_TEAM_BUTTON_TOOTLTIP.key,MANAGE_TEAM_SETTINGS.EDIT_TEAM_BUTTON_TOOTLTIP.value)}>
                      <Icon
                        type="edit"
                        onClick={() => {
                          setShowModal(true);
                          setIsEditTeam(true);
                          setSelectedTeam(value);
                        }}
                      />
                    </Tooltip>
                    <Tooltip placement="top" title={t(MANAGE_TEAM_SETTINGS.DELETE_TEAM_TOOLTIP.key,MANAGE_TEAM_SETTINGS.DELETE_TEAM_TOOLTIP.value)}>
                      <Icon
                        type="delete"
                        onClick={() => {
                          setSelectedTeam(value);
                          setDeleteModalVisible(true);
                        }}
                      />
                    </Tooltip>
                  </div>
                }
              >
                <UsersList>
                  {value.readAccess.map((user, key) => (
                    <div className={'read_access userName'}>
                      {user.adid
                        ? user.displayName
                        : user.firstName + ' ' + (user.lastName !== null ? user.lastName : '')}
                    </div>
                  ))}
                  {value.writeAccess.map((user, key) => (
                    <div className={'write_acess userName'}>
                      {user.adid
                        ? user.displayName
                        : user.firstName + ' ' + (user.lastName !== null ? user.lastName : '')}
                    </div>
                  ))}
                </UsersList>
                {value.readAccess.length + value.writeAccess.length === 0 && (
                  <NoUser>{t(MANAGE_TEAM_SETTINGS.EMPTY_USERS_LIST_LABEL.key,MANAGE_TEAM_SETTINGS.EMPTY_USERS_LIST_LABEL.value)}</NoUser>
                )}
              </Panel>
            );
          })}
      </Collapse>
    );
  };

  const handleAddTeam = async () => {
    if(isEnterprise || checkUserAccess('master')) {
      setShowModal(true);
      return;
    }
    setIsCheckingLimit(true);
    const response = await fetchUserDetails();
    if(response && response.statusCode === 1903 && response.errors && response.errors.length === 0) {
      setIsCheckingLimit(false);
      setUserDetails(response.data);
      const { team } = response.data.planMapping;
      setTeamLimit(team ? team : null);
      if(team) {
        if(teamCount < team) {
          setShowModal(true);
        } else {
          setUpgradeModal(true);
        }
      } else {
        team === null && setShowModal(true);
      } 
    } else {
      setIsCheckingLimit(false);
      message.error(t(MANAGE_TEAM_SETTINGS.CHECKING_TEAM_LIMIT_ERROR.key, MANAGE_TEAM_SETTINGS.CHECKING_TEAM_LIMIT_ERROR.value));
    }
  }

  return (
    <>
      {loading ? (
        <LoginContainer>
          <Loader />
        </LoginContainer>
      ) : (
        <>
          <UserDetailHeadingCover>
            <div>
              <h5>{t(MANAGE_TEAM_SETTINGS.MANAGE_TEAM_SETTINGS_TITLE.key,MANAGE_TEAM_SETTINGS.MANAGE_TEAM_SETTINGS_TITLE.value)}</h5>
              <p> {t(MANAGE_TEAM_SETTINGS.MANAGE_TEAM_SETTINGS_DESCRIPTION.key,MANAGE_TEAM_SETTINGS.MANAGE_TEAM_SETTINGS_DESCRIPTION.value)}</p>
            </div>
            <Button type="primary" className="add_user_btn" loading={isCheckingLimit} onClick={() => handleAddTeam()}>
            {isCheckingLimit ? t(MANAGE_TEAM_SETTINGS.WAIT_TO_ADD_TEAM_BUTTON.key,MANAGE_TEAM_SETTINGS.WAIT_TO_ADD_TEAM_BUTTON.value) : t(MANAGE_TEAM_SETTINGS.ADD_TEAM_BUTTON.key,MANAGE_TEAM_SETTINGS.ADD_TEAM_BUTTON.value)}
            </Button>
          </UserDetailHeadingCover>
          <TeamDetailsCard>{renderList()}</TeamDetailsCard>
          {showModal && (
            <AddTeamModal
              onCancel={() => {
                setShowModal(false);
                setIsEditTeam(false);
              }}
              onSuccess={onSuccess}
              isEditTeam={isEditTeam}
              selectedTeam={selectedTeam}
            />
          )}
          {deleteModalVisible && (
            <DeleteUserModal
              visible={deleteModalVisible}
              targetUser={selectedTeam}
              onCancel={handleDeleteTeam}
              isDeleteTeam={true}
            />
          )}
          {upgradeModal && (
            <UpgradePlanModal
              visible={upgradeModal}
                modalText={userDetails.planMapping.planName === 'Premium' ?
                  t(MANAGE_TEAM_SETTINGS.PREMIUM_PLAN_LIMIT_REACHED_ERROR.key, MANAGE_TEAM_SETTINGS.PREMIUM_PLAN_LIMIT_REACHED_ERROR.value, { emailId: SUPPORT_EMAIL_ID }) 
                : userDetails.planMapping.planName === 'Free' ? t(
                  MANAGE_TEAM_SETTINGS.FREE_PLAN_UPGRADE_MESSAGE.key,
                  MANAGE_TEAM_SETTINGS.FREE_PLAN_UPGRADE_MESSAGE.value,
                  { teamLimit })
                : t(MANAGE_TEAM_SETTINGS.STANDARD_PLAN_UPGRADE_MESSAGE.key, MANAGE_TEAM_SETTINGS.STANDARD_PLAN_UPGRADE_MESSAGE.value, { teamLimit })}
              onCancel={() => setUpgradeModal(false)}  
            />
        )}
        </>
      )}
    </>
  );
};
export default withTranslation(NAMESPACE)(TeamSettings);
